// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__Je6XS","Alert":"Layout_Alert__6YtYT"};